import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { MobilePageContainer } from 'components/Mobile/components/PageContainer/pageContainer.mobile';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';
import { HomeHeader } from 'components/Mobile/pages/home/components/HomeHeader/homeHeader';
import { QuickLinks } from 'components/Mobile/pages/home/components/QuickLinks/quickLinks';
import { SearchText } from 'components/Mobile/pages/home/components/SearchText/searchText';
import classes from 'components/Mobile/pages/home/home.mobile.module.scss';

export const HomeMobile = () => {
    useFullStoryPageView({ pageName: `${mobileAppConfig.home.title} (mobile)` });
    return (
        <MobilePageContainer className={classes.homeContainer}>
            <HomeHeader />
            <SearchText />
            <QuickLinks />
        </MobilePageContainer>
    );
};
